// src/components/forms/FormActions.js
// Row right-aligned com botões de ação do form (Salvar, Cancelar).
// Mobile: stack column full-width.
//
// API:
//   children — AppButton(s)
//   sticky   — se true, fixa no bottom (raro; usar só em forms longos)

import React from 'react'
import { Box, Stack } from '@mui/material'

export default function FormActions({ children, sticky = false, sx }) {
  return (
    <Box
      sx={{
        mt: 3,
        display: 'flex',
        justifyContent: { xs: 'stretch', sm: 'flex-end' },
        ...(sticky && {
          position: 'sticky',
          bottom: 0,
          bgcolor: 'background.paper',
          py: 2,
          borderTop: '1px solid',
          borderColor: 'divider',
          zIndex: 1,
        }),
        ...sx,
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1.5}
        sx={{ width: { xs: '100%', sm: 'auto' } }}
      >
        {children}
      </Stack>
    </Box>
  )
}
